/* unplugin-vue-components disabled */import script from "./xFieldLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./xFieldLabel.vue?vue&type=script&setup=true&lang=js"

import "./xFieldLabel.vue?vue&type=style&index=0&id=a76cbab4&lang=less"

const __exports__ = script;

export default __exports__